import { __assign, __extends } from "tslib";
import React from 'react';
import { PnmacUIButton, PnmacSubheading, PnmacTextInput, PnmacRowHeader, PnmacMediaQuery, PnmacPaper, PnmacMeta } from 'pnmac-universal-components';
import styles from '../../styles/styles.js';
import { connect } from "react-redux";
import * as Actions from "../../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import { SuccessMessage } from '../../components/SuccessMessage.js';
import { ErrorMessage } from '../../components/ErrorMessage.js';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { TrackerHitTypeLID_ENUM, TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, UserLanguage_ENUM } from '../../redux/events/events.js';
import { textStyle } from "../../v2/theme";
var PassWord = /** @class */function (_super) {
  __extends(PassWord, _super);
  function PassWord(props) {
    var _this = _super.call(this, props) || this;
    _this.submitPassword = function () {
      var _a = _this.state,
        currentPassword = _a.currentPassword,
        confirmNewPassword = _a.confirmNewPassword,
        newPassword = _a.newPassword;
      fetch("api/account/update_password", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer ".concat(_this.props.layout.token)
        },
        body: JSON.stringify({
          changedPassword: currentPassword.toString(),
          currentPassword: newPassword.toString(),
          confirmedPass: confirmNewPassword.toString(),
          loanId: _this.props.layout.selectedLoanNumber
        })
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        if (data) {
          _this.setState({
            confirmFinal: true,
            loading: false,
            errorMessage: false
          }, function () {});
        } else {
          _this.setState({
            errorMessage: true,
            loading: false,
            confirmFinal: false
          });
        }
      });
    };
    _this.state = {
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      confirmNewPasswordError: false,
      PasswordValidationError: false,
      confirmFinal: false,
      loading: false,
      viewnewpassword: false,
      viewexistingpassword: false,
      viewconfirmedpassword: false,
      errorMessage: false
    };
    return _this;
  }
  PassWord.prototype.render = function () {
    var _this = this;
    var _a = this.state,
      currentPassword = _a.currentPassword,
      newPassword = _a.newPassword,
      confirmNewPassword = _a.confirmNewPassword,
      confirmNewPasswordError = _a.confirmNewPasswordError,
      PasswordValidationError = _a.PasswordValidationError,
      confirmFinal = _a.confirmFinal,
      viewnewpassword = _a.viewnewpassword,
      viewexistingpassword = _a.viewexistingpassword,
      viewconfirmedpassword = _a.viewconfirmedpassword,
      errorMessage = _a.errorMessage;
    var translations = this.props.translations;
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        mediumLarge: "(min-width: 1024px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(PnmacMeta, {
        title: "Password"
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          width: "100%"
        }
      }, confirmFinal ? /*#__PURE__*/React.createElement(SuccessMessage, {
        onClick: function () {
          return _this.setState({
            confirmFinal: false
          });
        },
        message: translations.PasswordChanged
      }) : null, errorMessage ? /*#__PURE__*/React.createElement(ErrorMessage, {
        onClick: function () {
          return _this.setState({
            errorMessage: false
          });
        },
        message: translations.PasswordIncorrect
      }) : null, /*#__PURE__*/React.createElement(PnmacRowHeader, {
        rowHeaderContainerStyles: styles.accountSettings.titleContainer,
        item: translations.ChangePassword
      }), /*#__PURE__*/React.createElement(PnmacPaper, {
        containerStyles: {
          backgroundColor: "#FFF",
          padding: 25,
          marginBottom: 20,
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
          borderBottom: "1px solid #e9e9e9",
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "center",
          boxShadow: "rgba(0, 0, 0, 0.08) 2px 4px 12px",
          elevation: 1,
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-around",
          height: "inherit"
        }
      }, /*#__PURE__*/React.createElement(PnmacSubheading, {
        style: __assign(__assign({}, textStyle.defaultTextTitle), {
          fontSize: matches.small ? 14 : 16
        })
      }, /*#__PURE__*/React.createElement("label", {
        for: "lblCurrentPassword"
      }, translations.CurrentPassword)), /*#__PURE__*/React.createElement(PnmacSubheading, {
        style: __assign(__assign({}, textStyle.defaultTextTitle), {
          fontSize: matches.small ? 14 : 16
        })
      }, /*#__PURE__*/React.createElement("label", {
        for: "lblNewPassword"
      }, translations.NewPassword)), /*#__PURE__*/React.createElement(PnmacSubheading, {
        style: __assign(__assign({}, textStyle.defaultTextTitle), {
          fontSize: matches.small ? 14 : 16
        })
      }, /*#__PURE__*/React.createElement("label", {
        for: "lblConfirmNewPassword"
      }, translations.ConfirmNewPassword))), /*#__PURE__*/React.createElement("div", {
        style: __assign(__assign({}, styles.accountSettings.inputLineContainer), {
          marginLeft: matches.large ? 60 : 20
        })
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          position: "relative"
        }
      }, !_this.state.viewexistingpassword ? /*#__PURE__*/React.createElement("div", {
        onClick: function () {
          return _this.setState({
            viewexistingpassword: true
          });
        },
        style: styles.accountSettings.pwVisible
      }, /*#__PURE__*/React.createElement(VisibilityIcon, {
        fontSize: "inherit",
        color: "primary"
      })) : /*#__PURE__*/React.createElement("div", {
        onClick: function () {
          return _this.setState({
            viewexistingpassword: false
          });
        },
        style: styles.accountSettings.pwVisible
      }, /*#__PURE__*/React.createElement(VisibilityOffIcon, {
        fontSize: "inherit",
        color: "primary"
      })), /*#__PURE__*/React.createElement(PnmacTextInput, {
        textAlign: 'left',
        accessibilityLabel: "Current Password",
        nativeID: "lblCurrentPassword",
        idTag1: 'txtCurrentPassword',
        mode: "outlined",
        secureTextEntry: !_this.state.viewexistingpassword,
        style: {
          margin: 20,
          width: '80%'
        },
        label: translations.CurrentPassword,
        value: currentPassword,
        error: confirmNewPasswordError,
        onChangeText: function (currentPassword) {
          return _this.setState({
            currentPassword: currentPassword
          });
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          position: "relative"
        }
      }, !_this.state.viewnewpassword ? /*#__PURE__*/React.createElement("div", {
        onClick: function () {
          return _this.setState({
            viewnewpassword: true
          });
        },
        style: styles.accountSettings.pwVisible
      }, /*#__PURE__*/React.createElement(VisibilityIcon, {
        fontSize: "inherit",
        color: "primary"
      })) : /*#__PURE__*/React.createElement("div", {
        onClick: function () {
          return _this.setState({
            viewnewpassword: false
          });
        },
        style: styles.accountSettings.pwVisible
      }, /*#__PURE__*/React.createElement(VisibilityOffIcon, {
        fontSize: "inherit",
        color: "primary"
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PnmacTextInput, {
        textAlign: 'left',
        accessibilityLabel: "New Password",
        nativeID: "lblNewPassword",
        idTag1: 'txtNewPassword',
        mode: "outlined",
        secureTextEntry: !_this.state.viewnewpassword,
        style: {
          margin: 20,
          width: '80%'
        },
        label: translations.NewPassword,
        value: newPassword,
        onChangeText: function (newPassword) {
          return _this.setState({
            newPassword: newPassword
          });
        },
        error: PasswordValidationError,
        onBlur: function () {
          var _a;
          if (((_a = newPassword.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/g)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var blackListedWords = _this.props.translations.PasswordBlackListedWords;
            var match = blackListedWords === null || blackListedWords === void 0 ? void 0 : blackListedWords.split(',');
            var IsBlackWordMatch = false;
            for (var _i = 0, match_1 = match; _i < match_1.length; _i++) {
              var val = match_1[_i];
              if (newPassword.toLowerCase().includes(val)) {
                IsBlackWordMatch = true;
                break;
              }
            }
            if (IsBlackWordMatch) {
              _this.setState({
                PasswordValidationError: true,
                PasswordCommWordsError: true
              });
            } else {
              _this.setState({
                PasswordValidationError: false,
                PasswordCommWordsError: false
              });
            }
          } else {
            _this.setState({
              PasswordValidationError: true,
              PasswordCommWordsError: false
            });
          }
        }
      }), /*#__PURE__*/React.createElement("div", {
        style: __assign({
          color: 'red'
        }, textStyle.defaultTextDescription)
      }, _this.state.PasswordValidationError ? _this.state.PasswordCommWordsError ? "Must not be a commonly used password" : "Password must be at least 10 characters and must include an upper case letter, a lower case letter, one numeric digit, and a special character (ex: ! @ $ % ^ & * ( ) + ?)" : ""))), /*#__PURE__*/React.createElement("div", {
        style: {
          position: "relative"
        }
      }, !_this.state.viewconfirmpassword ? /*#__PURE__*/React.createElement("div", {
        onClick: function () {
          return _this.setState({
            viewconfirmpassword: true
          });
        },
        style: styles.accountSettings.pwVisible
      }, /*#__PURE__*/React.createElement(VisibilityIcon, {
        fontSize: "inherit",
        color: "primary"
      })) : /*#__PURE__*/React.createElement("div", {
        onClick: function () {
          return _this.setState({
            viewconfirmpassword: false
          });
        },
        style: styles.accountSettings.pwVisible
      }, /*#__PURE__*/React.createElement(VisibilityOffIcon, {
        fontSize: "inherit",
        color: "primary"
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PnmacTextInput, {
        textAlign: 'left',
        accessibilityLabel: "Confirm New Password",
        nativeID: "lblConfirmNewPassword",
        idTag1: 'txtConfirmNewPassword',
        mode: "outlined",
        style: {
          margin: 20,
          width: '80%'
        },
        label: translations.ConfirmNewPassword,
        value: confirmNewPassword,
        error: confirmNewPasswordError,
        secureTextEntry: !_this.state.viewconfirmpassword,
        onChangeText: function (confirmNewPassword) {
          return _this.setState({
            confirmNewPassword: confirmNewPassword
          });
        },
        onBlur: function () {
          if (newPassword != confirmNewPassword) {
            _this.setState({
              confirmNewPasswordError: true
            });
          } else {
            _this.setState({
              confirmNewPasswordError: false
            });
          }
        }
      }), /*#__PURE__*/React.createElement("div", {
        style: __assign({
          color: 'red'
        }, textStyle.defaultTextDescription)
      }, confirmNewPasswordError ? "‘New Password’ and ‘Confirm New Password’ do not match." : ""))))), /*#__PURE__*/React.createElement("div", {
        style: styles.accountSettings.buttonContainer
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        mode: 'contained',
        idTag1: 'btnPasswordChange',
        style: {
          marginTop: 20
        },
        loading: _this.state.loading,
        disabled: confirmNewPasswordError || PasswordValidationError || currentPassword == "" || confirmNewPassword == "" || newPassword == "",
        onClick: function () {
          if (!(confirmNewPasswordError || PasswordValidationError || currentPassword == "" || confirmNewPassword == "" || newPassword == "")) {
            _this.setState({
              loading: true
            }, function () {
              return _this.submitPassword();
            });
            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Password Change Button Clicked", 243);
          }
        }
      }, translations.Change)))));
    });
  };
  return PassWord;
}(React.Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(PassWord);